export const TIPO_GRUPO_IMPUESTO = {
  IMPUESTO_REPERCUTIDO: 0,
  IMPUESTO_RETENIDO: 1,
} as const

export type TipoGrupoImpuestoType =
  (typeof TIPO_GRUPO_IMPUESTO)[keyof typeof TIPO_GRUPO_IMPUESTO]
